export type InventoryRoute = {
	id: string;
};

export const ƒ_home: InventoryRoute = { id: '/[locale=locale]' };
export const ƒ_photographs: InventoryRoute = { id: '/[locale=locale]/[photographs=photographs]' };
export const ƒ_photograph: InventoryRoute = { id: '/[locale=locale]/[photographs=photographs]/[year]/[month]/[day]/[slug]' };
export const ƒ_thoughts: InventoryRoute = { id: '/[locale=locale]/[thoughts=thoughts]' };
export const ƒ_thought: InventoryRoute = { id: '/[locale=locale]/[thoughts=thoughts]/[year]/[month]/[day]/[slug]' };
export const ƒ_about: InventoryRoute = { id: '/[locale=locale]/[about=about]' };
export const ƒ_linkInBio: InventoryRoute = { id: '/[locale=locale]/[linkInBio=linkInBio]' };
export const ƒ_feed: InventoryRoute = { id: '/[locale=locale]/feed.xml' };

export function isRoute(route: { id: string | null }): route is InventoryRoute {
	return 'id' in route && !!route.id;
}

export const descendsFrom =
	(currentRoute: { id: string | null }) =>
	(someRoute: InventoryRoute): boolean => {
		return isRoute(currentRoute) && currentRoute.id.includes(someRoute.id);
	};

export const routeEq =
	(currentRoute: { id: string | null }) =>
	(someRoute: InventoryRoute): boolean => {
		return isRoute(currentRoute) && currentRoute.id === someRoute.id;
	};
